export const RazonesParada: { [key: string]: string } = {
    fin_jornada: 'Fin de Jornada',
    comida: 'Comida',
    medico: 'Médico',
    descanso_almuerzo: 'Descanso / Almuerzo',
    otra: 'Otra',
};

export default RazonesParada;
